import {API_URL_USERS} from '../constants';

export const apiBaseUsers = {
  baseUrl: API_URL_USERS,
  endpoints: {
    profile: '/details/v1/profile',
    updateProfileMetadata: '/details/v1/profile/metadata',
    verifySignUpCode: '/public/user/v1/signup/code',
    sourceOfFunds: '/user/v1/source-of-funds',
  },
};

export type OnboardingVersionType =
  | 'ONB_202403_V1'
  | 'ONB_202408_V2'
  | 'ONB_202412_V3';

export const OnboardingVersionV1 = 'ONB_202403_V1';
export const OnboardingVersionV2 = 'ONB_202408_V2';
export const OnboardingVersionV3 = 'ONB_202412_V3';

export enum E_ADDRESS_TYPE {
  BILLING = 'BILLING',
  SHIPPING = 'SHIPPING',
}
export type AddressType = (typeof E_ADDRESS_TYPE)[keyof typeof E_ADDRESS_TYPE];
